import { formatCurrency, parseCurrency } from "./invoiceUtils";
import { roundMoney } from "../utils/money.mjs";

const currencyCode = (invoice, fallback = "EUR") => String(invoice?.currency || fallback).trim().toUpperCase() || fallback;

export const summarizeInvoicesByCurrency = (invoices = [], amountOf = (invoice) => invoice.amount) => {
  const totals = new Map();
  invoices.forEach((invoice) => {
    const currency = currencyCode(invoice);
    const current = totals.get(currency) || 0;
    totals.set(currency, roundMoney(current + parseCurrency(amountOf(invoice)), currency));
  });
  return [...totals.entries()]
    .map(([currency, amount]) => ({ currency, amount }))
    .sort((left, right) => left.currency.localeCompare(right.currency));
};

export const summarizeBilledInvoicesByCurrency = (invoices = []) => summarizeInvoicesByCurrency(
  invoices.filter((invoice) => invoice?.documentType !== "credit-note"),
);

export const formatCurrencySummary = (summary = [], fallbackCurrency = "EUR") => {
  if (!summary.length) return formatCurrency(0, fallbackCurrency);
  return summary.map(({ currency, amount }) => formatCurrency(amount, currency)).join(" + ");
};

export const prioritizeCurrencySummary = (summary = [], preferredCurrency = "EUR") => {
  const preferred = String(preferredCurrency || "EUR").trim().toUpperCase();
  return [...summary].sort((left, right) => {
    if (left.currency === preferred && right.currency !== preferred) return -1;
    if (right.currency === preferred && left.currency !== preferred) return 1;
    return left.currency.localeCompare(right.currency);
  });
};

export const meaningfulCurrencySummary = (summary = []) => summary.filter(({ amount }) => Math.abs(Number(amount) || 0) >= 0.005);

export const invoiceOutstandingAmount = (invoice) => {
  if (invoice?.status === "Paid") return 0;
  return Math.max(0, parseCurrency(invoice?.amount) - Number(invoice?.paidAmount || 0));
};

export const formatInvoiceCurrencySummary = (invoices = [], amountOf, fallbackCurrency = "EUR") => (
  formatCurrencySummary(summarizeInvoicesByCurrency(invoices, amountOf), fallbackCurrency)
);
